// import 'react-app-polyfill/ie9'; // For IE 9-11 support
// import 'react-app-polyfill/stable';
// import 'react-app-polyfill/ie11'; // For IE 11 support
// import './polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import { createLogger } from 'redux-logger';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import createMiddlewareSaga from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import { IntlProvider } from 'react-intl';
import Services from 'services/index';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Store from './redux/reducers';
import rootSagas from './redux/sagas';
import i18n from './i18n';
import AppbarProvider from 'providers/AppbarProvider';
import CachedProvider from 'providers/CachedProvider';
import { showError } from 'helpers/handleError';

const client = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      showError(error);
    },
  }),
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

//* setup middleware
const sagaMiddleware = createMiddlewareSaga();
let middleware = applyMiddleware(sagaMiddleware);

if (process.env.NODE_ENV !== 'production') {
  middleware = composeWithDevTools(applyMiddleware(sagaMiddleware, createLogger()));
}

const store = createStore(Store, middleware);
sagaMiddleware.run(rootSagas);
Services.setupInterceptors(store);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <QueryClientProvider client={client}>
      <CachedProvider>
        <IntlProvider locale='en'>
          <I18nextProvider i18n={i18n}>
            <AppbarProvider>
              <App />
            </AppbarProvider>
          </I18nextProvider>
        </IntlProvider>
      </CachedProvider>
    </QueryClientProvider>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();

//! For use dispatch outside React Component
export const storeRedux = store;
